import TickerChip from "../../components/TickerChip";
import {DoubleLine} from "../../components/Labels";
import {isUUID} from "../../utils/strings";



export const ComparisonRowTitleComponent = ({symbol, record})=>{
    const isPortfolio = isUUID(symbol);
    return isPortfolio ? <DoubleLine title={record.name} text={'Portfolio'} /> : <TickerChip ticker={record}/>;

}


export const colorTableRow = (record, rowIndex) => {
    const color = record?.color || '#1A1E23';
    return {
        style: {
            background: `linear-gradient(to right, ${color} 5px, #fff 5px)`,
            zIndex: 100000,
        }
    }
}